<template>
    <div class="idea ">
        <div class="tab-box">
                <el-tabs v-model="compName"  >
                    <el-tab-pane name="MaterialWorkorder">
                        <template #label>
                            <span >工单素材<i class="el-icon-refresh" @click="refreshList"/></span>
                        </template>
                    </el-tab-pane>
                    <el-tab-pane label="本地上传" name="MaterialUpload"/>
                </el-tabs>
        </div>
        <div class="content">
           <keep-alive>
                <component
                    :is="compName"
                />
           </keep-alive>
        </div>
    </div>
</template>
<script>
import MaterialWorkorder from './materialWorkorder.vue'
import MaterialUpload from './materialUpload.vue'
export default {
    components: { MaterialUpload, MaterialWorkorder },
    data() { 
        return {
            compName: 'MaterialWorkorder'
        }
     },
    methods: {
        refreshList() {}
    }
}
</script>

<style lang="scss" scoped>
.idea {
    height: 850px;
    display: flex;
    flex-direction: column;
}
.tab-box {
    padding-left: 18px;
   height: 55px;
   position: relative;
}
.content {
    padding: 0 10px 10px;
    flex: 1;
    height: 0;
}
</style>